export default "/fonts/vendor/katex/dist/KaTeX_Math-BoldItalic.ttf?bf2d440b3a42ea78a998ccd32eb09d88";